"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewSummary = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const common_1 = require("@/components/common");
require("@/components/common");
/**
 * mm-review-summary
 * 상품의 평균 별점과 전체 리뷰 수를 간결하게 요약한다.
 */
let ReviewSummary = class ReviewSummary extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.rating = 0;
        this.reviewCount = 0;
    }
    render() {
        const rating = Math.min(5, Math.max(0, this.rating));
        const filledStars = Math.round(rating);
        return (0, lit_1.html) `
      <div class="stars" role="img" aria-label="5점 만점에 ${rating}점">
        ${Array.from({ length: 5 }, (_, index) => (0, lit_1.html) `
            <mm-icon
              name=${index < filledStars ? common_1.ICON_NAMES.FAVORITE_SELECTED : common_1.ICON_NAMES.FAVORITE}
            ></mm-icon>
          `)}
      </div>
      <mm-text weight="bold">${rating.toFixed(1)}</mm-text>
      <mm-text>리뷰 ${this.reviewCount.toLocaleString('ko-KR')}개</mm-text>
    `;
    }
};
ReviewSummary.styles = (0, lit_1.css) `
    :host {
      display: flex;
      align-items: center;
      gap: var(--space-2);
    }

    .stars {
      display: flex;
      gap: var(--space-1);
      color: var(--accent-color);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: Number })
], ReviewSummary.prototype, "rating", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Number, attribute: 'review-count' })
], ReviewSummary.prototype, "reviewCount", void 0);
ReviewSummary = __decorate([
    (0, decorators_js_1.customElement)('mm-review-summary')
], ReviewSummary);
exports.ReviewSummary = ReviewSummary;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmV2aWV3LXN1bW1hcnkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJyZXZpZXctc3VtbWFyeS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQTJEO0FBRTNELGdEQUFnRDtBQUNoRCwrQkFBNEI7QUFFNUI7OztHQUdHO0FBRUksSUFBTSxhQUFhLEdBQW5CLE1BQU0sYUFBYyxTQUFRLGdCQUFVO0lBQXRDOztRQWN1QixXQUFNLEdBQUcsQ0FBQyxDQUFBO1FBQ2lCLGdCQUFXLEdBQUcsQ0FBQyxDQUFBO0lBcUJ4RSxDQUFDO0lBbkJDLE1BQU07UUFDSixNQUFNLE1BQU0sR0FBRyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsRUFBRSxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsRUFBRSxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQTtRQUNwRCxNQUFNLFdBQVcsR0FBRyxJQUFJLENBQUMsS0FBSyxDQUFDLE1BQU0sQ0FBQyxDQUFBO1FBRXRDLE9BQU8sSUFBQSxVQUFJLEVBQUE7eURBQzBDLE1BQU07VUFDckQsS0FBSyxDQUFDLElBQUksQ0FDVixFQUFFLE1BQU0sRUFBRSxDQUFDLEVBQUUsRUFDYixDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxDQUFDLElBQUEsVUFBSSxFQUFBOztxQkFFUCxLQUFLLEdBQUcsV0FBVyxDQUFDLENBQUMsQ0FBQyxtQkFBVSxDQUFDLGlCQUFpQixDQUFDLENBQUMsQ0FBQyxtQkFBVSxDQUFDLFFBQVE7O1dBRWxGLENBQ0Y7OytCQUVzQixNQUFNLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQztvQkFDNUIsSUFBSSxDQUFDLFdBQVcsQ0FBQyxjQUFjLENBQUMsT0FBTyxDQUFDO0tBQ3ZELENBQUE7SUFDSCxDQUFDOztBQWxDTSxvQkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7Ozs7R0FZbEIsQ0FBQTtBQUMyQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7NkNBQVc7QUFDaUI7SUFBdEQsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxTQUFTLEVBQUUsY0FBYyxFQUFFLENBQUM7a0RBQWdCO0FBZjNELGFBQWE7SUFEekIsSUFBQSw2QkFBYSxFQUFDLG1CQUFtQixDQUFDO0dBQ3RCLGFBQWEsQ0FvQ3pCO0FBcENZLHNDQUFhIn0=